import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceNavigationEntityState} from "../reducers/ecommerce-navigation.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceNavigationState = (websiteId: number) =>
    createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceNavigation.entities[websiteId]);

export const getMenus = (websiteId: number) => createSelector(getEcommerceNavigationState(websiteId),
    (state: IEcommerceNavigationEntityState) => {
        return state.menus;
    }
);

export const getMenusLoading = (websiteId: number) => createSelector(getEcommerceNavigationState(websiteId),
    (state: IEcommerceNavigationEntityState) => state && state.loading
);
